module.exports = {
	baseURL: "/",
	baseRoute: "/*",
	version: "e7ffd95",
	host: "https://chemnet.berkeley.edu/chemnet",
	reactHost: "https://chemnet.berkeley.edu",
}
